const toFiniteNumber = (value) => {
  if (value === null || typeof value === 'undefined' || value === '') return null
  const n = Number(value)
  return Number.isFinite(n) ? n : null
}

const derivePercentDisplay = ({
  periodValue,
  preferredPercent = null,
  totalValue = null,
  fallbackTotal = null,
}) => {
  const preferred = toFiniteNumber(preferredPercent)
  if (preferred !== null) return preferred

  const total = Number(totalValue || 0)
  const period = Number(periodValue || 0)
  if (total > 0) return (period / total) * 100

  const fallback = Number(fallbackTotal || 0)
  return fallback > 0 ? (period / fallback) * 100 : 0
}

const deriveTotalFromPercent = ({
  nextPercent,
  totalValue = null,
  fallbackTotal = null,
  currentValue,
  currentPercent,
}) => {
  const nextPct = Number(nextPercent || 0)
  const total = Number(totalValue || 0)
  const fallback = Number(fallbackTotal || 0)
  const current = Number(currentValue || 0)
  const currentPct = toFiniteNumber(currentPercent)

  if (total > 0) return Math.max(0, total * (nextPct / 100))

  if (fallback > 0) return Math.max(0, fallback * (nextPct / 100))

  if (current > 0 && currentPct !== null && currentPct > 0) {
    return Math.max(0, current * (nextPct / currentPct))
  }

  if (current > 0) {
    return nextPct === 0 ? 0 : Math.max(0, current * (nextPct / 100))
  }

  return 0
}

export const deriveWeeklyMonthPercentDisplay = ({
  periodValue,
  preferredPercent = null,
  monthTotal = null,
  fallbackTotal = null,
}) => derivePercentDisplay({
  periodValue,
  preferredPercent,
  totalValue: monthTotal,
  fallbackTotal,
})

export const deriveWeeklyTotalFromMonthPercent = ({
  nextPercent,
  monthTotal = null,
  fallbackTotal = null,
  currentTotal,
  currentPercent,
}) => deriveTotalFromPercent({
  nextPercent,
  totalValue: monthTotal,
  fallbackTotal,
  currentValue: currentTotal,
  currentPercent,
})

export const deriveWeeklyPlanPercentDisplay = ({
  actualSales,
  salesPlan,
  preferredPlanPercent = null,
  monthSalesTotal = null,
}) => {
  return deriveWeeklyMonthPercentDisplay({
    periodValue: salesPlan,
    preferredPercent: preferredPlanPercent,
    monthTotal: monthSalesTotal,
    fallbackTotal: actualSales,
  })
}

export const deriveWeeklySalesTotalFromPlanPercent = ({
  nextPlanPercent,
  monthSalesTotal = null,
  actualSales,
  currentSalesTotal,
  currentPlanPercent,
}) => {
  return deriveWeeklyTotalFromMonthPercent({
    nextPercent: nextPlanPercent,
    monthTotal: monthSalesTotal,
    fallbackTotal: actualSales,
    currentTotal: currentSalesTotal,
    currentPercent: currentPlanPercent,
  })
}

